<div class="container-fluid">
    <div class="row">
      <div style="margin-top:1%; margin-bottom:-50px; margin-left:10px">
        <h6>
       <span style="padding-right:5px"></span>
         <!-- <i class="fa fa-globe"></i>
          <b>Route </b>-->
        </h6>
      </div>
    </div>
    <hr>
    <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
    <div class="col-md-12 p-0">
      <div class=" form-group ">
    
        <div *ngIf="tranportAssociation" class="row">
          <div class="col-sm-4">
            <label>Transport Association</label>
            <input formControlName="transport_assoc" [value] = "tranportAssociation.description"  title="Transport Association" class="form-control form-control-sm" type="text" readonly />
          </div>
          <br>
        </div>
        <br>
        
        <div *ngIf="btnRadio=='1' || btnRadio=='2' || btnRadio=='3' || isCheck"  class="row">        
          
          <div class="col-sm-4">
            <label>Route Name</label>
            <!-- <input formControlName="description" title="Enter a name for the route that is easy to remember (e.g. Harare to Joburg)" class="form-control form-control-sm" type="text" readonly/>
            -->
            
              <select formControlName="route_name" [disabled]="isDupApplication" title="Select a route" [(ngModel)]="selectedRoute" class="form-control form-control-sm"  (change)="checked()">
                <option disabled >Select route</option>
                    <!-- <option *ngIf="defaultValue  != ''" disabled [value]="defaultValue">{{defaultValue}}</option> -->
                <ng-container >
                    <option *ngFor="let r of ownRoutes" [ngValue]="r" selected="r.id == selectedRoute.id">{{r.description}}</option>
                </ng-container>
                </select>
                
          </div>
        
        </div>
  
  <br>
        
        <div class="col-sm-12 p-0 mt-2"  *ngIf="btnRadio=='1' || btnRadio=='2' || btnRadio=='3' || isCheck" >
         
          <!-- <ckeditor title="" [readonly]="isDupApplication" formControlName="route_detail"  (input)="changes()" debounce="500">
          </ckeditor> -->
          <quill-editor [styles]="{height: '400px'}"  formControlName="route_detail"
                [modules]="quillConfig">
              </quill-editor>
          <button *ngIf="!isDupApplication" title="Update Route Details" name="saveroutedetails" type="submit" id="btnSave" (click)="updateRouteForApproval()"  class="btn btn-md m-clr pull-right hd-btn" style="width:auto; margin-right:0px;margin-bottom:5px;margin-top:5px;">Update Route Details</button>
          </div>
      </div>
      <br/>
      <br/>
  
    </div>
    </form>
  </div>
  
  <ngx-loading [show]="pageload"></ngx-loading>
  